<template>
  <v-app id="app" class="public">
    <div :class="bg">
      <app-bar v-if="!this.header"></app-bar>
      <app-bar-login v-if="this.header == 'login'"></app-bar-login>
      <app-bar-register v-if="this.header == 'register'"></app-bar-register>
      <app-bar-company-list v-if="this.header == 'company-list'"
                            :companyCount="this.companyCount"></app-bar-company-list>
      <app-bar-company-add v-if="this.header == 'company-add'"></app-bar-company-add>
      <app-bar-add-code v-if="this.header == 'add-code'"></app-bar-add-code>
      <app-bar-custom v-if="this.header== 'custom-header'" :headerText="this.headerText" :headerSubText="this.headerSubText"></app-bar-custom>
      <app-bar-forgot-password v-if="this.header == 'forgot-password'"></app-bar-forgot-password>
      <slot></slot>
      <div class="fb-customerchat" page_id="105505214752716" logged_in_greeting="สอบถามเพิ่มเติม ?" logged_out_greeting="สอบถามเพิ่มเติม"></div>
    </div>
  </v-app>
</template>

<script>
import AppBar from '@/components/public/app-bar.vue'
import AppBarLogin from '@/components/public/app-bar-login.vue'
import AppBarRegister from '@/components/public/app-bar-register.vue'
import AppBarCompanyList from '@/components/public/app-bar-company-list.vue'
import AppBarCompanyAdd from '@/components/public/app-bar-company-add.vue'
import AppBarAddCode from '@/components/public/app-bar-add-code.vue'
import AppBarCustom from '@/components/public/app-bar-custom-header.vue'
import AppBarForgotPassword from '@/components/public/app-bar-forgot-password.vue'

export default {
  name: 'Public',
  components: {
    AppBar,
    AppBarLogin,
    AppBarRegister,
    AppBarCompanyList,
    AppBarCompanyAdd,
    AppBarAddCode,
    AppBarCustom,
    AppBarForgotPassword
  },
  props: ['header', 'companyCount', 'bg', 'headerText', 'headerSubText'],
  created() {
    if (window.FB) {
      window.FB.CustomerChat.show(false)
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}

.public .container {
  max-width: 1140px;
}
</style>
